<template>
    <div class="recruitment_dynamic_container" v-show="list.length > 0">
        <div class="title">
            招聘动态
            <a class="more-btn" href="/campus_recruiting/search">查看更多校招职位 <i class="iconfont iconchevron-right"></i> </a>
        </div>
        <div class="content">
            <a class="item" v-for="item in list" :key="item.image" :href="item.link" target="_blank">
                <img :src="item.image"/>
                <p>{{item.title}}</p>
            </a>
        </div>
    </div>
</template>

<script>
import api from '@/api';

    export default {
        data() {
            return {
                list: [],
            }
        },
        created() {
            api.jobs.getBanner({position: 24})
                .then(res => this.list = res.data)
                .catch(err => Promise.reject(err));
        },
    }
</script>

<style lang="scss" scoped>
.recruitment_dynamic_container {
    width: 100%;
    margin: 27px 0;
}
.title {
    margin-bottom: 24px;
    color: #404040;
    font-size: 22px;
    font-weight: bold;
    height: 30px;
    position: relative;
    line-height: 30px;
    a {
        position: absolute;
        right: 0;
        cursor: pointer;
    
        font-size: 14px;
        color: #606060;
        &:hover{
          color: #9c9c9c;
          &>i{
            color: #9c9c9c;
          }
        }
        &>i{     
         position: relative;
         color: #959595;
         top: 1px;
        }
    }
}
.content {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .item {
        border-radius: 6px;
        margin-bottom: 16px;
        background-color: #ffffff;
        color: #404040;
        height: 168px;
        width: 226px;
        margin-right: 16px;
        &:nth-child(5n) {
            margin-right: 0;
        }
        &:hover{
            box-shadow: 0px 2px 28px 0px rgba(10,44,156, .1);

            // p {
            //     color: #FF6644;
            // }
        }
    }

    img {
        border-radius: 6px;
        margin: auto;
        width: 226px;
        height: 120px;
    }

    p {
        // text-align: center;
        margin: 14px 16px;
    }
}
</style>
